// position:fixed / clientX·clientY 좌표계(layout viewport)에서 "실제로 보이는 영역"의 박스.
// iOS는 소프트 키보드가 뜨면 layout viewport는 그대로 두고 visual viewport를 아래로
// 패닝하므로(useSoftKeyboardViewportFix.ts 참조), window.innerWidth/innerHeight
// (= visual viewport 크기)만으로는 원점 오프셋을 알 수 없다 — 그 값으로 fixed 좌표를
// 클램프하면 키보드가 뜬 동안 요소가 화면 상단으로 끌려 올라간다.
// offsetLeft/offsetTop은 layout viewport 기준 오프셋이라 fixed 클램프에 정확히 맞는 값이다
// (이 앱은 문서 스크롤 범위가 0이라 pageTop과 동일하지만, fixed에는 offset이 정의상 옳다).
export function visibleViewportBox(): { left: number; top: number; width: number; height: number } {
  const vv = window.visualViewport;
  if (!vv) return { left: 0, top: 0, width: window.innerWidth, height: window.innerHeight };
  return { left: vv.offsetLeft, top: vv.offsetTop, width: vv.width, height: vv.height };
}
